import React from "react"
import { Button, Card, CardContent, Grid } from "@mui/material"
import { SimulateInfo } from "./components/SimulateInfo"
import SimulateTimers from "./components/SimulateTimers"
import { Link } from "react-router-dom"

const SimulatesCards = ({ data }) => {

    return (
        <Card sx={{ width: '100%' }}>
            <CardContent>
                <SimulateInfo data={data} />
                <SimulateTimers data={data} />
                <Grid container mt="5px">
                    <Button
                        fullWidth
                        variant="contained"
                        component={Link}
                        to={`/resultado-simulado/${data._id}`}                        
                        sx={{ backgroundColor: "primary" }}>
                        Ver respostas
                    </Button>
                </Grid>
            </CardContent>
        </Card>
    )


}

export default SimulatesCards 